import routerOptions0 from "/Users/cofidisdigital/Documents/repositories/credito-nuxt/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
}